const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      color: theme.colors[1],
      background: theme.colors[4],
    },
    wrapper: {
      extend: theme.wrapper,
    },
    intro: {
      paddingTop: 100,
      // paddingBottom: 100,
    },
    additionalText: {
      '& .TextBlock__title': {
        fontSize: 16,
        textTransform: 'uppercase',
      },
      '& .TextBlock__text': {
        fontSize: 24,
      },
    },
    pageElements: {
      '& > *': {
        paddingTop: 100,
        '&:last-child': {
          paddingBottom: 100,
        },
      },
    },
    image: {
      width: '100%',
    },
    highlights: {
      paddingTop: 100,
      justifyContent: 'space-between',
    },
    highlightItem: {
      display: 'flex',
      flexDirection: 'column',
      fontFamily: theme.fonts[1],
      fontWeight: 700,
      fontSize: '11vw',
      lineHeight: 1,
      width: 'auto',
      '-webkit-text-fill-color': 'transparent',
      '-webkit-text-stroke-width': '1px',
      '-webkit-text-stroke-color': theme.colors[1],
      '& span': {
        fontFamily: theme.fonts[0],
        fontSize: 16,
        marginTop: 20,
        '-webkit-text-fill-color': theme.colors[1],
        '-webkit-text-stroke-width': 0,
        '-webkit-text-stroke-color': 'transparent',
      },
    },
    logoWrapper: {
      justifyContent: 'space-between',
    },
    logos: {
      maxWidth: 220,
    },
    column: {
      columnCount: 3,
      '& p': {
        lineHeight: 1.5,
      },
    },
    listItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& > *': {
        '&:not(:first-child)': {
          marginTop: 15,
        },
      },
    },
  }

  output[theme.mediaInverse.sm] = {
    intro: {
      paddingTop: 50,
      paddingBottom: 50,
    },
    highlightItem: {
      fontSize: 100,
    },
    logoWrapper: {
      alignItems: 'center',
    },
    column: {
      display: 'flex',
    },
  }

  return output
}

export default style
